import React from 'react'
import "./click-out.css"

const ClickOut = ({show, onClose, onCloseAll}) => {
    return (
        <div className={`obe-overlay ${show ? "show" : ""}`}>
            <div onClick={e => e.stopPropagation()} className="obe-dialog">
                <div className="obe-body">
                    <h3 className="obe-title">דלג על השלבים</h3>
                    <p className="obe-message">
                        האם אתה בטוח שתרצה לדלג על השלבים? יכול להיות שיהיו בעתיד הטבות שלא יגיעו אליך
                    </p>
                </div>
                <div className="obe-actions">
                    <button onClick={onClose} className="obe-btn-primary">
                        המשך במילוי
                    </button>
                    <button onClick={onCloseAll} className="obe-btn-ghost">
                        דלג לתמונות
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ClickOut;
